// extracted by mini-css-extract-plugin
export default {"blinking":"DailyCountdown_blinking__Qj1jS","blinker":"DailyCountdown_blinker__LdeMd","fastBlinking":"DailyCountdown_fastBlinking__th62T"};